// extracted by mini-css-extract-plugin
module.exports = {"footer":"CopySurveyModal_footer__3rHxC","modal-content":"CopySurveyModal_modal-content__3LikH","modal-body":"CopySurveyModal_modal-body__3XJMY"};